import React from 'react';
import { Navigate } from 'react-router-dom';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { Router } from '../../libs/services';
import { useAccounts } from '../../libs/accounts/AccountsContext';

export function AccountsPage(): React.ReactElement {
  const { t } = useTranslation();
  const { accounts } = useAccounts();
  const redirectPath = Router.getPath('loyaltyPrograms', {
    accountId: accounts[0]?.id,
  });

  if (!accounts.length) {
    return <QlfPlaceholder primaryText={t('accounts.empty')} />;
  }

  return <Navigate to={redirectPath} />;
}
